import React from 'react';
import PropTypes from 'prop-types';
export const RadioInput = ({
  name,
  value,
  currentChecked,
  onChange,
  disabled
}) => React.createElement("input", {
  type: "radio",
  id: value,
  disabled: disabled,
  name: name,
  value: value,
  onChange: e => onChange(e.target.value),
  checked: value === currentChecked
});
RadioInput.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  currentChecked: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool
};
RadioInput.defaultProps = {
  disabled: false
};